import { Avatar, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import styles from './CircleAvatar.module.scss';

export const CircleAvatar: FC<{
  circleAvatarUrl: string;
  circleName: string;
}> = ({ circleAvatarUrl, circleName }) => {
  const matches = useMediaQuery('(max-width:767px)');

  return (
    <div
      style={{
        backgroundImage: matches ? `url(${circleAvatarUrl})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      aria-hidden="true"
      role="presentation"
      className={styles.avatar}
    >
      <div>
        {!matches && (
          <div>
            <Avatar
              src={circleAvatarUrl}
              alt={`Avatar of ${circleName}`}
              sx={{ width: 300, height: 300, borderRadius: '50%' }}
            >
              N
            </Avatar>
          </div>
        )}
      </div>
    </div>
  );
};
